import { Avatar } from "antd";
import "./user-avatar.css";
// const SIZES = { small: "22", default: "34" };

type UserAvatarProps = {
  url: string;
  // email: string;
  fullName: string;
  isRect: boolean;
  // size: string;
  // Stable hook for UI automation. antd v6 changed the avatar's rendered
  // class list, breaking selectors that matched on `class`; this gives the
  // automation team a class-independent locator. Overridable so multiple
  // avatars on a page can be told apart.
  dataTestId?: string;
};
function UserAvatar({
  url,
  fullName,
  isRect,
  dataTestId = "user-avatar"
}: UserAvatarProps) {
  const shape = isRect ? "square" : "circle";
  const avatarWidth = isRect ? "100px" : "30px";
  const avatarHeight = isRect ? "100px" : "30px";
  // const _size = size || "default";
  const letterSplit = (fullName && fullName.split(" ")) || ["", ""];
  let letters = letterSplit.map((word: string) => word[0]).join("");
  if (letters.length > 3) {
    letters = letters.slice(0, 3);
  }
  // if (!url && email) {
  //   url = `https://www.gravatar.com/avatar/${email}?d=robohash`;
  // }

  // const heightWidth = SIZES[_size as keyof typeof SIZES] || "34";

  return (
    <div className="avator">
      {!url && (
        <Avatar
          data-testid={dataTestId}
          className="flex items-center justify-center"
          shape={shape}
          style={{
            width: avatarWidth,
            height: avatarHeight,
            // antd v4 gave avatars an opaque #ccc background; v6's default
            // avatarBg is the translucent `colorTextPlaceholder`
            // (rgba(0,0,0,0.25)), which goes dark on the dark navbar and hides
            // the dark initials. Restore the v4 opaque grey (#cccccc).
            backgroundColor: "var(--ciq-gray-400)",
            textTransform: "uppercase"
          }}
        >
          {letters}
        </Avatar>
      )}
      {url && (
        <img
          data-testid={dataTestId}
          src={url}
          alt="Profile"
          height={30}
          width={30}
        />
      )}
    </div>
  );
}

export default UserAvatar;
